import type { Database } from 'sql.js';
import { SQL_WHERE_OFFLINE_UPLOAD_PENDING } from '@core/infrastructure/driven/sqljs/offlineUploadSqlPredicates.ts';
import { queryOne } from '@core/infrastructure/driven/sqljs/sqljsSqlitePrimitives.ts';

/** Redemptions that would be included in the next offline sync export. */
export function countRedencionesPendingOfflineExport(db: Database): number {
  const row = queryOne(
    db,
    `SELECT COUNT(*) AS n FROM redenciones_bono WHERE ${SQL_WHERE_OFFLINE_UPLOAD_PENDING}`,
    [],
  );
  return Math.max(0, Math.floor(Number(row?.n ?? 0)));
}
